import {
  API_AUTH_TOKEN,
  API_LOGIN,
  API_LOGOUT,
} from "../../utils/api/ApiConstant";
import showToast from "../../utils/toastUtil";
import { userAction } from "./user-slice";
import { uiActions } from "../ui/ui-slice";
import { postAxios, postFetchAxios } from "../../Services/commonService";
import { decodeToken } from "../../helper/common";
import { marketAction } from "../market/market-slice";

export const loginUser = async (dispatch, payload, navigate) => {
  try {
    if (payload) {
      dispatch(uiActions.setLoading(true));
      const data = await postAxios({ url: API_LOGIN, payload });

      if (data.is2FA) {
        navigate("/VerifyCode", { state: payload });
        return;
      }
      if (data) {
        dispatch(userAction.setToken(data?.accessToken));
        dispatch(userAction.setSToken(data?.sToken));
        dispatch(userAction.setSurl(data?.sUrl));

        // decode token here and store
        const res = decodeToken(data?.accessToken);
        console.log("🚀 ~ loginUser ~ res:", res);
        dispatch(userAction.updateUser(res));
      }
      dispatch(uiActions.setLoading(false));
    }
  } catch (err) {
    console.log("🚀 ~ loginUser ~ err:", err);
    dispatch(uiActions.setLoading(false));
  }
};

export const logoutUser = async (dispatch) => {
  try {
    // await postAxios({ url: API_LOGOUT, payload: {} });
    // dispatch(userAction.clearMarketWatchScripts([]));
    dispatch(userAction.setToken(""));
    dispatch(userAction.setSToken(""));
    dispatch(userAction.setSurl(""));
    // dispatch(marketAction.setMarketWatchScripts(""));
    await dispatch(userAction.clearUser());
    localStorage.clear();
    showToast.success("Logout successfully");
  } catch (error) {
    console.log("🚀 ~ logoutUser ~ error:", error);
    // showToast.error(error?.data?.message);
  }
};

let isLogoutInProgress = false; // Prevent multiple logout calls

export const handleAxiosError = async (error, dispatch, token) => {
  const status = error?.response?.status;
  const isNetwork = error?.message === "Network Error";
  if ((isNetwork || status === 401 || status === 403) && !isLogoutInProgress) {
    isLogoutInProgress = true;

    try {
      await dispatch(userAction.clearUser());
      localStorage.clear();

      if (status === 401 || status === 403) {
        showToast.error("Session expired. Please login again.");
      } else {
        showToast.error("Network error. Logged out for security.");
      }

      window.location.href = "/login"; // ✅ Force redirect to login
    } catch (logoutError) {
      console.error("Logout error:", logoutError);
    }
  }

  return Promise.reject(error); // Let the original error continue to propagate
};
